import { KIND, Tag as RawTag, TagVariant } from 'baseui/tag';
import { CloseSVG } from 'common/assets';
import stylesColors from 'common/styles/styles.colors';
import { Action, ActionContainer } from 'components/styles';
import * as React from 'react';

import { InputBoxContainer, RawInputTag, TagContainer } from './style';

export interface TagItemProps {
  id?: string;
  key?: string;
  label: string;
}

export interface TagProps {
  index?: string;
  readOnly?: boolean;
  tags?: TagItemProps[] | null;
  onChange?: (value: TagItemProps[]) => void;
  name: string;
  placeholder?: string;
  disabled?: boolean;
  error?: boolean;
  inputType?: 'text' | 'number';
}
const randomNumber = Math.floor(Math.random() * 1000);

export default function Tag(props: TagProps) {
  const inputRef = React.useRef<HTMLInputElement | null>();
  const {
    error,
    tags,
    onChange,
    name,
    placeholder,
    disabled,
    readOnly,
    inputType = 'text',
  } = props;
  const uniqueId = `tagId-${name ? name + '-' : ''}${randomNumber}`;
  const onEnter = React.useCallback<
    React.KeyboardEventHandler<HTMLInputElement>
    // eslint-disable-next-line node/handle-callback-err
  >(
    (e) => {
      const value = inputRef.current?.value.trimStart() as string;
      if (e.key === 'Enter') {
        if (value) {
          onChange?.((tags || [])?.concat({ label: value, key: value }));
          //@ts-ignore
          inputRef.current.value = '';
        }

        e.preventDefault();
        return false;
      }
    },
    [onChange, tags],
  );

  const onDeleteTag = (idx?: number) => {
    onChange?.((tags || [])?.filter((_, index) => idx !== index));
  };

  const _disabled = disabled || readOnly;

  return (
    <InputBoxContainer
      onClick={() => {
        !_disabled && inputRef.current?.focus();
      }}
      key={uniqueId}
      $disabled={_disabled}
      $error={error}
    >
      <TagContainer>
        {(tags || []).map((item, idx) => (
          <RawTag
            key={item.id + item.label}
            kind={KIND.custom}
            variant={TagVariant.solid}
            closeable={!_disabled}
            onActionClick={() => onDeleteTag(idx)}
            color={stylesColors.primaryDark}
            overrides={{
              Root: {
                style: {
                  opacity: _disabled ? '0.5' : 1,
                },
              },
            }}
          >
            {item.label}
          </RawTag>
        ))}
        {!_disabled && (
          <RawInputTag
            //@ts-ignore
            ref={inputRef}
            type={inputType}
            className=""
            onKeyDown={onEnter}
            placeholder={placeholder || 'Enter something'}
          />
        )}
      </TagContainer>
      {!_disabled && (tags || []).length > 0 && (
        <ActionContainer $style={{ flex: 0 }}>
          <Action
            onClick={() => {
              onChange?.([]);
            }}
            $style={{
              backgroundColor: 'black',
              borderRadius: '999px',
              padding: '1px',
            }}
          >
            <CloseSVG
              {...{
                width: 8,
                height: 8,
                color: 'white',
              }}
            />
          </Action>
        </ActionContainer>
      )}
    </InputBoxContainer>
  );
}
